<div class="checkbox medium-type" [ngClass]="{ 'checkbox-disabled': ctrlField()?.disabled }">
  <label class="checkbox-container flex ps-medium-r" [ngClass]="{ 'flex--center': center() }" [for]="checkboxId">
    @if (ctrlField(); as checkboxControl) {
      <input
        class="is-vishidden"
        type="checkbox"
        [attr.aria-required]="isRequired()"
        [attr.disabled]="checkboxControl.disabled ? 'disabled' : null"
        [formControl]="$any(checkboxControl)"
        [id]="checkboxId"
        [name]="controlName()"
        [value]="checkboxValue()"
        aria-describedby="checkbox-error-box"
      />
    }
    @if (showCheckboxIcon()) {
      <div
        class="icons ms-xsmall-r"
        [ngClass]="{
          'error-900-text signal-error-notification-border-icon-text': ctrlField()?.invalid && ctrlField()?.touched,
          'icons--rounded': theme() === CheckBoxTheme.ROUNDED,
          'nordic-blue-900-text text-icon-primary': ctrlField()?.valid,
        }"
        aria-hidden="true"
      >
        @if (ctrlField()?.value) {
          <fcom-icon
            data-testid="icon-selected"
            [class]="iconSize()"
            [name]="
              theme() === CheckBoxTheme.SQUARE
                ? SvgLibraryIcon.CHECKBOX_SELECTED
                : SvgLibraryIcon.CHECKMARK_BUTTON_SELECTED
            "
          ></fcom-icon>
        } @else {
          <fcom-icon
            data-testid="icon-unselected"
            [class]="iconSize()"
            [name]="
              theme() === CheckBoxTheme.SQUARE
                ? SvgLibraryIcon.CHECKBOX_UNSELECTED
                : SvgLibraryIcon.CHECKMARK_BUTTON_UNSELECTED
            "
          ></fcom-icon>
        }
      </div>
    }
    <div class="flex flex--column">
      @if (translationPrefix() && useLabelText()) {
        <span class="text font-body-1 medium-type font-label-medium"
          >{{ translationPrefix() + '.label' | finLocalization }}
          @if (isRequired()) {
            *
          }
        </span>
      }
      <div data-testid="text-content" class="text">
        <ng-content />
      </div>
    </div>
  </label>

  @if (translationPrefix() && ctrlField()?.invalid && ctrlField()?.touched) {
    <div
      data-testid="error-label"
      class="error-label error-900-text signal-error-notification-border-icon-text font-body-2 font-body-small"
      id="checkbox-error-box"
      aria-live="polite"
    >
      @if (isRequired() && showRequiredError()) {
        <span>{{ translationPrefix() + '.required' | finLocalization }}</span>
      }
    </div>
  }
</div>
